import { FC } from 'react'
import { format } from 'date-fns'
import { AptiveIcon } from '@aptive-env/storybook'

import { ICalendarDate } from 'interface/calendar'
import { convert24HourTo12Hour } from 'utils/convertHour'
import { getCalendarEventTypeColors } from 'utils/color'

interface CalendarDayListProps {
  data: Array<ICalendarDate>
}

const CalendarDayList: FC<CalendarDayListProps> = ({ data }) => {
  return (
    <div className="overflow-auto flex-auto">
      {data.map((item, index) => (
        <div className="flex flex-col p-4 gap-2.5" key={index}>
          <div className="flex items-center justify-between bg-[#F9FAFB] rounded-lg h-[44px] px-2">
            <div className="flex items-center gap-1">
              <div className={`text-xSmallBold font-inter uppercase ${index === 0 ? 'text-text-default' : 'text-[#A9A9A9]'}`}>{item.name}</div>
              <div className={`text-xSmall font-inter ${index === 0 ? 'text-text-default' : 'text-[#A9A9A9]'}`}>{format(item.date, 'MMMM d')}</div>
            </div>
            {item.weather && (
              <div className="flex items-center">
                <span className="font-inter text-[#A9A9A9] text-smallBold">{item.weather.temperature.day}º</span>
                <span className="font-inter text-[#A9A9A9] text-small">/ {item.weather.temperature.night}º</span>
                <img src={item.weather.icon} alt={item.weather.forecast} className="w-[20px] h-[20px] rounded ml-1" />
              </div>
            )}
          </div>
          <>
            {item.events.length === 0 ? (
              <div className="text-small text-text-default text-center">No Events</div>
            ) : (
              item.events.map((event) => (
                <div className="px-4 flex flex-col cursor-pointer" key={event.id}>
                  <div className="flex items-center gap-1.5">
                    <AptiveIcon
                      className={'w-[12px] h-[12px] stroke-none'}
                      icon="clock"
                      style={{ fill: getCalendarEventTypeColors(event.event_type).dark }}
                      isFilled
                    />
                    <div className="text-sm leading-normal text-text-default">
                      { `${convert24HourTo12Hour(event.start_at)} - ${convert24HourTo12Hour(event.end_at)}` }
                    </div>
                  </div>
                  <div className="text-smallBold text-text-default">{event.title}</div>
                </div>
              ))
            )}
          </>
        </div>
      ))}
    </div>
  )
}

export default CalendarDayList
